/**
 * Regra dinâmica de cotações (T7 / issue #51).
 *
 * Regra:
 *   - 0 cotações                       → pendente (false)
 *   - ≥ 3 cotações                     → fulfilled (true) — mantém hard cap de 3
 *   - qualquer cotação ≤ €200          → fulfilled (true)  — compra de baixo valor
 * Caso contrário (apenas > €200 com < 3 cotações) → pendente (false).
 *
 * Espelha a regra do backend (`MaintenanceRequest#hasRequiredQuotations`).
 */

/**
 * Threshold (€) abaixo do qual uma cotação torna as restantes opcionais,
 * e abaixo do qual uma compra com cotação única é auto-aprovada
 * (fonte `AUTO_PURCHASE_LOW_VALUE`).
 *
 * Espelha `AUTO_APPROVE_PURCHASE_THRESHOLD` do backend
 * (`backend/src/config/purchaseThresholds.js`). Alterar em ambos os lados.
 */
export const LOW_VALUE_QUOTE_THRESHOLD = 200

/**
 * Alias semântico para o mesmo limiar, usado pela regra de auto-aprovação
 * de compra de baixo valor. Mantém a paridade 1:1 com o backend.
 */
export const AUTO_APPROVE_PURCHASE_THRESHOLD = LOW_VALUE_QUOTE_THRESHOLD

/** Forma mínima de uma cotação para avaliação da regra. */
export interface QuoteLike {
  quotedValue?: number | string | null
}

/**
 * Indica se o conjunto de cotações cumpre a regra dinâmica de obrigatoriedade.
 */
export function computeQuotationsFulfilled(
  quotations: QuoteLike[] | undefined | null
): boolean {
  if (!quotations || quotations.length === 0) return false
  if (quotations.length >= 3) return true
  return quotations.some(q => {
    if (q == null) return false
    const raw = (q as { quotedValue?: unknown }).quotedValue
    // Number(null) === 0 e Number(undefined) === NaN — filtrar explicitamente
    // para não classificar cotações sem valor como "de baixo valor".
    if (raw == null || raw === '') return false
    const value = Number(raw)
    return Number.isFinite(value) && value <= LOW_VALUE_QUOTE_THRESHOLD
  })
}
